import React, { useState } from 'react';
import styled from 'styled-components';
import responsive from '../utils/responsive';
import TextInput from './TextInput';

const InlineForm = styled.form`
  display: flex;
  flex: 0 1 auto;
  justify-content: center;
  align-items: center;
  height: 3em;

  width: 40%;
  ${responsive.sm.andSmaller`
    width: auto;
  `}

  > input {
    height: 100%;
    width: 70%;
    ${responsive.sm.andSmaller`
      font-size: ${props => props.theme.textSize.m};
      line-height: ${props => props.theme.lineHeight.m};
    `}
  }
`;

const Button = styled.button`
  width: 30%;
  height: 100%;
  border: none;
  background: ${props =>
    props.theme.button.primary.backgroundColor.lighten(0.2).toHex()};
  color: ${props => props.theme.button.primary.color.toHex()};
  font-size: ${props => props.theme.textSize.l};
  ${responsive.sm.andSmaller`
    font-size: ${props => props.theme.textSize.m};
  `}

  :hover {
    opacity: 0.9;
  }

  :active {
    opacity: 0.7;
  }

  :disabled {
    opacity: 0.8;
  }

  transition: all 0.2s ease;
  margin-left: -${props => props.theme.border.width};
`;

const encode = data => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&');
};

const ContactForm = ({ placeholder, sendAction, sentLabel }) => {
  const [value, setValue] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = e => {
    e.preventDefault();

    fetch('/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({ 'form-name': 'contact', email: value }),
    }).catch(error => console.log(error));

    setSubmitted(true);
  };

  return (
    <InlineForm
      name="contact"
      data-netlify="true"
      onSubmit={handleSubmit}
      disabled={submitted}
    >
      <input type="hidden" name="form-name" value="contact" />
      <TextInput
        required={true}
        isDisabled={submitted}
        placeholder={placeholder}
        type="email"
        name="email"
        value={value}
        onChange={setValue}
      />
      <Button type="submit" disabled={submitted}>
        {!submitted ? sendAction : sentLabel}
      </Button>
    </InlineForm>
  );
};

export default ContactForm;